import clsx from 'clsx'
import {orderBy} from 'lodash'
import React from 'react'
import {Redirect, Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import CloseIcon from '@mui/icons-material/Close'

import Navigation from './Navigation'
import Timer from './Timer'
import Sections from './Sections'
import Section from './Section'
import Question from './Question'
import FinalizeAssessment from './FinalizeAssessment'
import FullScreenDialog from 'components/FullScreenDialog'

import {createPost} from '../../../helpers/command'

const saveAnswers = createPost('quiz','saveTeacherAnswers')

const useStyles = makeStyles(assessmentStyles)
 

export default function TakeAssessment (props) {
  const imported = props.imported
  if (props.context.attemptId && !imported) throw new Error('Imported assessment requires imported test adapter')
  const classes = useStyles()
  const [finalizeOpen, setFinalize] = React.useState(false)

  function closeFinalize() {
    setFinalize(false)
  }

  function openFinalize() {
    setFinalize(true)
  }

  const context = {...props.context, saveAnswers: imported ? imported.saveAnswers : saveAnswers, importedFinalize: imported && imported.finalize}
  const {quizAssessmentToTake: assessment, assessment: assessmentId, translate, sectionId, link, quizTypesMap} = context
  const {content = {}} = assessment 
  const {title, type} = content

  const assessmentLoaded = !context.quizSearch['assessment-to-take']

  const sections = (imported || assessment.assessmentId == assessmentId)
    ? orderBy(Object.values(content.sections || {}),'index')
    : []

  const redirect = !imported && sections.length > 0 && !sectionId
  const redirectLink = redirect && link({sectionId: sections[0].id})

  const typeName = imported ? (context.languageId === 'es' ? 'Examen' : 'Exam') : translate(quizTypesMap[type])

  const isSection = !context.questionId

  const closeLink = imported ? imported.closeLink : link({action: 'preview', sectionId: undefined, questionId: undefined})

  return redirectLink
    ? (<Redirect to={redirectLink} />)
    : (<FullScreenDialog open={true} >
        <Box className={classes.root}>
          <Box className={classes.header}>
            <Box className={classes.label}>{translate('test-preview-header')}</Box>
            {!imported?.readOnly && <Box className={clsx(classes.button, classes.finalize)} onClick={openFinalize}>
              <Box className="label">{translate('finalize-test')}</Box>
            </Box>}
            <FinalizeAssessment
              isOpen={finalizeOpen}
              context={context}
              onClose={closeFinalize}
              imported={imported ? {onFinalize: imported.finalize} : undefined}
            />
            <Link className={clsx(classes.button, classes.close)} to={closeLink}>
              <Box className="icon"><CloseIcon /></Box>
              <Box className="label">{translate('close')}</Box>
            </Link>
          </Box>
          <Box className={classes.preview}>
            <Paper className={classes.view}>
              <Box className={classes.viewHeader}>
                <Box className="type">{typeName}:</Box>
                <Box className="title">{title}</Box>
              </Box>
              <Box className={classes.viewContent}>
                {isSection && (<Section {...{sections, context, content}} />)}
                {!isSection && (<Question {...{sections, context, content}} />)} 
              </Box>
              <Box className={classes.viewNavigation}>
                <Navigation {...{sections, context, content}} />
              </Box>
            </Paper>
            <Box className={classes.side}>
              {assessment.duration > 0 && (<Timer context={context} />)}
              <Sections {...{sections, context}} />
            </Box>
          </Box>
        </Box>
       </FullScreenDialog>
      )
}


export function assessmentStyles (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    header: {
      padding: 10,
      display: 'flex',
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }
    },
    label: {
      flexGrow: 1,
      color: '#4d5361',
      fontSize:'13pt',
      fontWeight: 'bold'
    },
    button: {
      textDecoration: 'none',
      color: '#fff',
      display: 'flex',
      padding: '7px 15px 7px 12px',
      backgroundColor:'#2ca5ec',
      borderRadius: 3,
      '& >div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
      '& .label': {
        fontSize: '13pt'
      },
      cursor: 'pointer',
      '&:hover': {
      },
    },
    close: {
      marginLeft: 20,
      '& .icon': {
        marginTop: -3,
        marginRight: 3,
        fontSize: '8pt'
      },
    },

    preview: {
      display: 'flex',
      padding: 10,
      flexGrow: 1,
      overflowY: 'hidden'
    },
    view: {
      flexGrow: 1,
      overflowY: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
    viewHeader: {
      display: 'flex',
      color: '#4d5361',
      fontSize:'13pt',
      padding: 20,
      borderBottom: 'solid 1px #d3d8db',
      "& .type": {
        fontWeight: 'bold'
      },
      "& .title": {
        marginLeft: 3
      }
    },
    viewContent: {
      display: 'flex',
      flexGrow: 1,
      overflowY: 'hidden',
    },
    viewNavigation: {
      borderTop: 'solid 1px #d3d8db',
      padding: 20
    },
    side: {
      marginLeft: 25,
      display: 'flex',
      flexDirection: 'column',
      minWidth: 255,
      maxWidth: 255
    },
  }
}
